import React, { useEffect } from 'react';
// import { Form } from 'react-bootstrap';
import dayjs from 'dayjs';
import { useIMask } from 'react-imask';
import { ReactComponent as PhoneIcon } from 'assets/icons_3/phone.svg';
import FormText from '../FormText';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

interface IPhoneInputProps {
  className?: string;
  name?: string;
  inputValue: string | undefined;
  isValid?: boolean;
  isInvalid?: boolean;
  error?: string;
  onChange: (value: string) => void;
  placeholder?: string
  label?: string
  id?: string
  disabled?: boolean
  required?: boolean
  /** Маска ввода, по умолчанию узбекистанский формат */
  mask?: string
}

const PhoneInput = ({
  className, name, placeholder, isInvalid, isValid, inputValue, onChange, label, id, error,
  disabled, required, mask,
}: IPhoneInputProps) => {
  const handleChange = ((value: string, maskRef: any) => {
    onChange(maskRef.unmaskedValue);
  });

  const maskConfig = React.useMemo(() => ({
    mask: mask || '+000 00 000 0000',
    autofix: true,
    lazy: true,
    overwrite: true,
  }), [mask]);

  const {
    ref,
    setTypedValue,
  } = useIMask(maskConfig, {
    onAccept: handleChange,
    onComplete: handleChange,
  });

  useEffect(() => {
    setTypedValue(inputValue || '');
  }, [inputValue, setTypedValue]);

  return (
    <FormText
      id={id}
      type="text"
      className={className}
      name={name}
      size="md"
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      ref={ref as React.RefObject<HTMLInputElement>}
      isValid={isValid}
      isInvalid={isInvalid}
      error={error}
      qaElement="phone-input"
      qaElementFeedback="edit-user-phone-error"
      Icon={PhoneIcon}
    />
  );
};

PhoneInput.defaultProps = {
  className: '',
  name: '',
  isValid: undefined,
  isInvalid: undefined,
  mask: undefined,
};

export default PhoneInput;
